import React from 'react';
import { Clock3 } from 'lucide-react';
import { cn } from '../../../../lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../ui/tooltip';

interface RootCauseHistoricalBadgeProps {
  className?: string;
  tooltip?: string;
  showLabel?: boolean;
}

const RootCauseHistoricalBadge: React.FC<RootCauseHistoricalBadgeProps> = ({
  className,
  tooltip = 'Historical only. Root cause classification is disabled for new records, but existing report data remains available.',
  showLabel = false,
}) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            showLabel
              ? 'inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.08em] text-amber-900'
              : 'inline-flex h-4 w-4 items-center justify-center text-amber-700',
            className
          )}
          aria-label={tooltip}
        >
          <Clock3 className="h-4 w-4" />
          {showLabel && <span>Historical only</span>}
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" sideOffset={8}>
        {tooltip}
      </TooltipContent>
    </Tooltip>
  );
};

export default RootCauseHistoricalBadge;
